import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MuiLink from '@material-ui/core/Link';
import { Link } from 'react-router-dom';
import SkeletonBody from '@afosto/components-react/SkeletonBody';
import { organisations } from '@afosto/contacts/api/Organisations';

const BASE_URL = process.env.REACT_APP_BASE_APP_URL;
const CONTACTS_APP_ORIGIN = BASE_URL.replace('{app}', 'contacts');

const OrganisationFormatter = ({ organisationId }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [organisation, setOrganisation] = useState(null);
  const isSameOrigin = window.location.origin === CONTACTS_APP_ORIGIN;

  useEffect(() => {
    let isMounted = true;

    const fetchOrganisation = async id => {
      setIsLoading(true);

      try {
        const response = await organisations.viewOrganisation(id);
        const { data = null } = response;

        if (isMounted) {
          setOrganisation(data);
        }
      } catch (err) {
        if (isMounted) {
          setOrganisation(null);
        }
      } finally {
        if (isMounted) {
          setIsLoading(false);
        }
      }
    };

    if (organisationId && organisationId !== '') {
      fetchOrganisation(organisationId);
    }

    return () => {
      isMounted = false;
    };
  }, [organisationId]);

  if (isLoading) {
    return <SkeletonBody lines={1} />;
  }

  if (isSameOrigin) {
    return organisation ? (
      <MuiLink variant="subtitle1" component={Link} to={`/organisations/${organisationId}`}>
        {organisation?.name}
      </MuiLink>
    ) : (
      '-'
    );
  }

  return organisation ? (
    <MuiLink variant="subtitle1" href={`${CONTACTS_APP_ORIGIN}/organisations/${organisationId}`}>
      {organisation?.name}
    </MuiLink>
  ) : (
    '-'
  );
};

OrganisationFormatter.propTypes = {
  organisationId: PropTypes.string,
};

OrganisationFormatter.defaultProps = {
  organisationId: undefined,
};

export default OrganisationFormatter;
